export default "__VITE_ASSET__Bn7vfz$u__"